const TodoData = [

    {
    id:1,
    todoName: "Meet With Caterer",
    todoDetails: "Meet with Juan Carlo in order to plan the menu for the wedding",
    location:"Marie Calendar's",
    created: "2019-22-04T16:00:01.250Z"

    },

    {
    id: 2,
    todoName: "Meet With DJ",
    todoDetails: "Meet with DJ Lambda to pick music for the wedding reception",
    location: "Coder's Basement",
    created: "2019-22-04T18:00:01.250Z"

    },

    {
    id: 3,
    todoName: "Meet With Client",
    todoDetails: "Meet with the Bride for dress fitting",
    location: "Brides in Bundles",
    created: "2019-22-04T13:00:01.250Z"

    }


]

export default TodoData